<template>
  <div id="app">
    <PageNotification
      v-if="!appBootstrapReady"
      :loading="appBootstrapLoading"
      :errored="appBootstrapErrored"
    />
    <template v-if="appBootstrapReady">
      <NavBar v-if="showAppShell"/>
      <BreadCrumb v-if="showAppShell"/>
      <router-view :key="$route.fullPath"></router-view>
      <FooterView v-if="showAppShell"/>
    </template>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import BreadCrumb from '@/components/BreadCrumb.vue'
import FooterView from '@/components/FooterView.vue'
import PageNotification from '@/components/ui/PageNotification.vue'
import { devSkipAuth } from '@/devMode'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: { NavBar, BreadCrumb, FooterView, PageNotification },
  computed: {
    ...mapState(['appBootstrapLoading', 'appBootstrapErrored', 'appBootstrapReady']),
    showAppShell () {
      return Boolean(this.authState?.isAuthenticated || devSkipAuth)
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
